/* unplugin-vue-components disabled */import script from "./OperationsKpis.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationsKpis.vue?vue&type=script&setup=true&lang=js"

import "./OperationsKpis.vue?vue&type=style&index=0&id=6f39512f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f39512f"]])

export default __exports__